// Single source of truth for company details used across the site and the
// legal pages. Update here and every page follows.
export const company = {
  name: 'Parnasa Apps',
  legalName: 'Parnasa S.r.l.s.',
  tagline: 'Next-Gen Mobile Experiences',
  domain: 'parnasapps.com',
  url: 'https://parnasapps.com',
  email: 'contact@parnasapps.com',
  address: {
    street: 'Via del Casaletto 385',
    postalCode: '00151',
    city: 'Rome',
    country: 'Italy',
    countryCode: 'IT',
  },
  addressOneLine: 'Via del Casaletto 385, 00151 Rome, Italy',
  hours: 'Monday – Friday, 09:00 – 18:00 CET',
  // Supervisory authority for an Italy-established controller (GDPR Art. 77).
  supervisoryAuthority: {
    name: 'Garante per la protezione dei dati personali',
    url: 'https://www.garanteprivacy.it',
  },
  legalUpdated: '18 August 2026',
} as const;

export const legalPaths = {
  privacy: '/privacy',
  terms: '/terms',
  cookies: '/cookies',
} as const;
